@if (shown()) {
  @if (greeting(); as line) {
    <!-- A sibling of the bird, so speaking never changes the bird's box. -->
    <app-skipper-speech-bubble
      class="greeting"
      [class.from-right]="onRight()"
      [text]="line"
      [tailSide]="onRight() ? 'right' : 'left'"
      [maxWidth]="170"
      [style.left.px]="onRight() ? null : settled().x + c.width - 4"
      [style.right.px]="onRight() ? bounds().right - settled().x - 4 : null"
      [style.top.px]="settled().y - 6"
      (click)="onTap()" />
  }

  <div
    #bird
    class="bird"
    role="button"
    tabindex="0"
    aria-keyshortcuts="Enter Space ArrowUp ArrowDown ArrowLeft ArrowRight"
    [attr.aria-label]="label()"
    [class.tucked]="tucked()"
    [class.edge-right]="onRight()"
    [class.dragging]="dragging()"
    [style.width.px]="tucked() ? c.tuckAssemblyWidth : c.width"
    (pointerdown)="onPointerDown($event)"
    (keydown)="onKeydown($event)">
    @if (tucked()) {
      <!-- Drawn first so Skipper leans out IN FRONT of the dock: emerging, not parked. -->
      <span class="dock" [style.width.px]="c.tuckBarWidth" [style.height.px]="c.tuckBarHeight"></span>
    } @else {
      <span class="contact-shadow" [style.width.px]="c.width * 0.52"></span>
    }
    <app-skipper-avatar
      class="avatar"
      [size]="c.size"
      [mood]="mood()"
      [mirrored]="tucked() && onRight()"
      [style.left.px]="tucked() && !onRight() ? avatarOffset : tucked() ? null : 0"
      [style.right.px]="tucked() && onRight() ? avatarOffset : null"
      [style.top.px]="tucked() ? c.size * 0.06 : 0" />
  </div>
}
